export default __webpack_public_path__ + "static/media/gif.69034a62.png";